import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayeeFilterOptions } from "../../../../Payees/hooks/usePayeeFilterOptions";

export function useBuildConfig() {
  const payeeOptions = usePayeeFilterOptions();

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [];

    config.push({
      title: "Contractor",
      name: "payeeId",
      type: "select",
      apiOptions: payeeOptions
    });

    config.push({
      title: "Date range",
      name: "dateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    return config;
  }, [payeeOptions]);
}
